import SubmissionsTab from "./SubmissionsTab";

export default function GeneralInterestTab(props) {
  return <SubmissionsTab {...props} collectionName="generalInterest" label="General Business Interest"
    summaryKeys={["companyOrName", "areaOfInterest"]}/>;
}
